export const getWindowBasePath = (slash = true) => {
    const pathWithoutSlash = getWindowBasePathWithoutSlash()
    return slash ? `${pathWithoutSlash}/` : pathWithoutSlash
}

const getWindowBasePathWithoutSlash = () => {
    const { origin } = window.location
    return origin.endsWith('/') ? origin.slice(0, -1) : origin
}
